import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login      from './pages/auth/Login';
import Dashboard  from './pages/dashboard/Dashboard';
import LeadsList  from './pages/leads/LeadsList';
import LeadCreate from './pages/leads/LeadCreate';
import LeadDetail from './pages/leads/LeadDetail';
import UsersList  from './pages/users/UsersList';
import UserForm   from './pages/users/UserForm';
import RolesList  from './pages/RolesList';
import Followups  from './pages/Followups';
import Masters    from './pages/Masters';
import BsaMaster  from './pages/BsaMaster';
import Reports    from './pages/Reports';
import Incentive  from './pages/Incentive';

import ProtectedRoute from './components/ProtectedRoute';
import authService    from './services/authService';

function AppRoutes() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleForceLogout = () => {
      authService.clearAuthData();
      navigate('/login', { replace: true });
    };
    window.addEventListener('auth:logout', handleForceLogout);
    return () => window.removeEventListener('auth:logout', handleForceLogout);
  }, [navigate]);

  return (
    <Routes>

      <Route path="/login" element={authService.isAuthenticated() ? <Navigate to="/dashboard" replace /> : <Login />} />

      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

      {/* Leads */}
      <Route path="/leads"            element={<ProtectedRoute permission="lead_read">  <LeadsList />  </ProtectedRoute>} />
      <Route path="/leads/create"     element={<ProtectedRoute permission="lead_create"><LeadCreate /> </ProtectedRoute>} />
      <Route path="/leads/:id"        element={<ProtectedRoute permission="lead_read">  <LeadDetail /> </ProtectedRoute>} />
      <Route path="/leads/:id/edit"   element={<ProtectedRoute permission="lead_update"><LeadCreate /> </ProtectedRoute>} />
      <Route path="/leads/:id/followup" element={<ProtectedRoute permission="lead_update"><LeadDetail /></ProtectedRoute>} />

      {/* Users */}
      <Route path="/users"            element={<ProtectedRoute permission="user_read">  <UsersList />  </ProtectedRoute>} />
      <Route path="/users/create"     element={<ProtectedRoute permission="user_create"><UserForm />   </ProtectedRoute>} />
      <Route path="/users/:id/edit"   element={<ProtectedRoute permission="user_update"><UserForm />   </ProtectedRoute>} />

      {/* Roles */}
      <Route path="/roles"            element={<ProtectedRoute permission="role_read">  <RolesList />  </ProtectedRoute>} />

      {/* Followups */}
      <Route path="/followups"        element={<ProtectedRoute permission="followup_read"><Followups /></ProtectedRoute>} />

      {/* Masters */}
      <Route path="/masters"          element={<ProtectedRoute permission="product_read"><Masters />   </ProtectedRoute>} />

      {/* BSA Master — separate page due to complexity (Phase 2 will expand it) */}
      <Route path="/bsa"              element={<ProtectedRoute permission="product_read"><BsaMaster /> </ProtectedRoute>} />

      {/* Reports */}
      <Route path="/reports"          element={<ProtectedRoute permission="report_read"><Reports />    </ProtectedRoute>} />

      {/* Incentive Calculation */}
      <Route path="/incentive"        element={<ProtectedRoute permission="report_read"><Incentive />  </ProtectedRoute>} />

      <Route path="/"  element={<Navigate to="/dashboard" replace />} />
      <Route path="*"  element={<Navigate to="/dashboard" replace />} />

    </Routes>
  );
}

function App() {
  return (
    <>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick draggable pauseOnHover theme="light" />
    </>
  );
}

export default App;
